export const Brand = require(`./${process.env.BRAND}`).default;
